<app-toolbar-item [label]="(showLogin() ? 'app.__MAP_LOGIN_TOOLTIP' : 'app.__MAP_LOGOUT_TOOLTIP') | AsyncLang | async">
  @if (showLogin()) {
    <a class="is-flex is-align-center is-fullheight text-grey-90" [attr.href]="loginHref">
      <app-icon name="account" class="text-24" />
    </a>
  } @else {
    @if (showLogout()) {
      <a class="is-flex is-align-center is-fullheight text-grey-90" [attr.href]="logoutHref">
        <app-icon name="log-out" class="text-24" />
      </a>
    }
  }
</app-toolbar-item>
